export default {
  setToken (state, data) {
    state.token = data
  },
  setAccount (state, data) {
    state.account = data
  }
}
